﻿import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {Directive, Input} from '@angular/core';
import {ZaIdValidationErrors, ZaIdValidationResult, ZaIdValidatorService} from '@shared/utils/za-id-validator.service';

@Directive({
    selector: '[ZaIdValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: ZaIdValidatorDirective,
            multi: true,
        },
    ]
})
export class ZaIdValidatorDirective implements Validator {
    validate(control: AbstractControl): ValidationErrors | null {
        return ZaIdValidationFn(control);
    }
}

export function ZaIdValidationFn(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
        return null;
    }

    const validator = new ZaIdValidatorService();
    validator.setId(control.value);

    const result: ZaIdValidationResult = validator.parse();

    switch (result.error) {
        case ZaIdValidationErrors.InvalidCheckSum:
            return {'invalidId': result.error};
        case ZaIdValidationErrors.InvalidLength:
            return {'invalidIdLength': result.error};
        default:
            return null;
    }
}
